import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// ----------------------------------------------------------------------
type ResponsiveQuery = "up" | "down" | "between" | "only";
type ResponsiveStart = "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";
type ResponsiveEnd = "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";

export function useResponsive(
  query: ResponsiveQuery,
  start: ResponsiveStart,
  end?: ResponsiveEnd
): boolean {
  const theme = useTheme();
  if (query === "up") {
    const mediaUp = useMediaQuery(theme.breakpoints.up(start));
    return mediaUp;
  }
  if (query === "down") {
    const mediaDown = useMediaQuery(theme.breakpoints.down(start));
    return mediaDown;
  }
  if (query === "between") {
    if (typeof end !== "undefined") {
      const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end));
      return mediaBetween;
    }
  }
  const mediaOnly = useMediaQuery(theme.breakpoints.only(start));
  return mediaOnly;
}

// ----------------------------------------------------------------------

export function useWidth(): ResponsiveStart {
  const theme = useTheme();

  const keys = [...theme.breakpoints.keys].reverse();

  return (
    keys.reduce((output: ResponsiveStart | null, key: ResponsiveStart) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));

      return !output && matches ? key : output;
    }, null) || "xs"
  );
}
